/**
 * =========================================================
 * Content Tools Config
 * =========================================================
 *
 * Declarative sidebar tool definitions for the Content admin
 * domain.
 *
 * Notes
 * - This first-pass config is intentionally small
 * - Tools are grouped by active content domain
 * - Actions remain stub-friendly for now
 * =========================================================
 */

import type { ContentDomain } from '@/features/admin/content/types/contentTypes'

export interface ContentTool {
  name: string
  action: string
}

export const contentTools: Record<ContentDomain, ContentTool[]> = {
  creatures: [
    {
      name: 'Create Creature',
      action: 'createCreature',
    },
    {
      name: 'Creature Table',
      action: 'editCreatures',
    },
    {
      name: 'Creature Stats Table',
      action: 'editCreatureStats',
    },
  ],
  items: [
    {
      name: 'Create Item',
      action: 'createItem',
    },
    {
      name: 'Item Table',
      action: 'editItems',
    },
  ],
  factions: [
    {
      name: 'Faction Table',
      action: 'editFactions',
    },
  ],

  organizations: [],

  locations: [],
}